import SideBarLayout from "@/features/erp/components/sidebar/SideBarLayout";
import { BriefcaseBusiness, Layers2Icon, LucideHouse } from "lucide-react";
import type { ReactNode } from "react";
import { Outlet } from "react-router";

type Props = {
    children?: ReactNode
}

export default function ProvidersLayout({children} : Props) {    
  return (
    <SideBarLayout links={[
        {
            label: 'Tablero', 
            path: 'dashboard',
            icon: <LucideHouse />
        },
        {
            label: 'Gestion', 
            path: 'manage',
            icon: <BriefcaseBusiness />
        },
        {
            label: 'Plantillas', 
            path: 'templates',
            icon: <Layers2Icon />
        }   
    ]}>
        {children ?? <Outlet />}
    </SideBarLayout>
  )
}
